module.exports = __webpack_public_path__ + "static/media/177-mauritania.76fadc9f.svg";